import React from "react";
import StatusBadge from "../StatusBadge";

const InfoRow = ({ label, value }) => (
  <div className="flex items-start justify-between gap-4 border-t border-slate-100 py-3 first:border-t-0 first:pt-0">
    <dt className="min-w-0 text-sm text-slate-500 shrink-0">{label}</dt>
    <dd className="max-w-[60%] text-right text-sm font-medium text-slate-900 break-words">{value || "—"}</dd>
  </div>
);

const OnboardingStepBusinessDetails = ({ tenant }) => {
  if (!tenant) {
    return (
      <p className="text-sm text-slate-400 italic">Business data not available.</p>
    );
  }

  return (
    <div className="space-y-5">
      <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <h4 className="text-sm font-semibold text-slate-950">Business profile</h4>
        <dl className="mt-4">
          <InfoRow label="Name" value={tenant.name} />
          <InfoRow label="Slug" value={tenant.slug} />
          <InfoRow label="Industry" value={tenant.industry} />
          <InfoRow label="Type" value={tenant.business_type} />
          <InfoRow label="Plan" value={tenant.plan} />
          <InfoRow
            label="Status"
            value={<StatusBadge status={tenant.status} />}
          />
        </dl>
      </section>

      {/* <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <h4 className="text-sm font-semibold text-slate-950">Owner information</h4>
        <dl className="mt-4">
          <InfoRow label="Name" value={tenant.owner_name} />
          <InfoRow label="Email" value={tenant.owner_email} />
          <InfoRow label="Phone" value={tenant.owner_phone} />
          <InfoRow label="Country" value={tenant.country} />
          <InfoRow label="Timezone" value={tenant.timezone} />
        </dl>
      </section> */}

      <section className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
        <p className="text-xs text-slate-500 leading-relaxed">
          This is a read-only summary of the business details collected during business creation.
          To update these values, use the business details page.
        </p>
      </section>
    </div>
  );
};

export default OnboardingStepBusinessDetails;
